import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/nimblr': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M246.6 299.3c15.6 0 27.2 11.5 27.2 27s-11.6 27-27.2 27c-15.7 0-27.1-11.6-27.1-27s11.5-27 27.1-27zM113 326.3c0-15.6 11.7-27 27.2-27 15.5 0 27.1 11.5 27.1 27s-11.5 27-27.1 27c-15.4 0-27.2-11.3-27.2-27zM191.8 159c98.4 0 177.8 78.9 177.8 176.5 0 97.6-79.6 176.5-177.8 176.5-98.1 0-177.8-78.9-177.8-176.5v-335.5l45.3 227c30.2-48.2 97.8-68 132.5-68zM191.8 467.1c73.2 0 132.5-59 132.5-131.6 0-72.7-59.2-131.5-132.5-131.5-73.3 0-132.5 58.9-132.5 131.6 0 72.7 59.2 131.6 132.5 131.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/nimblr.js
// module id = 941
// module chunks = 0